module.exports = __webpack_public_path__ + "img/1185x407px.9c421e5d.png";